import { PageLayout } from 'coreOld/components';

import { messagesPath } from './routePaths';

export const messages = {
  path: messagesPath(),
  exact: true,
  isPrivate: true,
  element: <PageLayout title="Messages"></PageLayout>,
};
